"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ModelStatus_1 = require("../../types/ModelStatus");
const Component_1 = __importDefault(require("../Component"));
const spinner_png_1 = __importDefault(require("../../resources/img/spinner.png"));
class SidebarComponent extends Component_1.default {
    constructor(playlists) {
        super();
        this.playlists = playlists;
    }
    getTemplate() {
        const isLoading = this.playlists.status === ModelStatus_1.ModelStatus.Pending;
        return `
      <aside class="aside">
        <h2 class="aside__h2 visually-hidden">Левая панель навигации</h2>
        <nav class="aside__nav">
          <div class="aside__search-container"></div>
          <ul class="aside__list">
          </ul>
          ${isLoading ? `<li class="sidebar-loading loading loading_small"><img class="loading__spinner" src="${spinner_png_1.default}" alt="Идет загрузка"></li>` : ''}
        </nav>
      </aside>
    `;
    }
}
exports.default = SidebarComponent;
